export const WAVE_FREE_TRIAL_ACCESSABLE_IDS = [14, 31, 4, 79, 104];
